import React from "react";
import Skeleton from "react-loading-skeleton";

export const ProductCardSkeleton = () => {
  return (
    <div className="gg-flex gg-flex-col gg-gap-5">
      {[...Array(3)].map((_, index) => (
        <Skeleton key={index} className="gg-h-[5.6rem] gg-w-full sm:gg-h-28" />
      ))}
    </div>
  );
};
